export default __webpack_public_path__ + "static/media/search-icon.6c95e853.svg";